import React, { useState, Fragment } from 'react';

//import ViewportItemRow from '../components/ViewportItemRow';
import ViewportItemState from '../map/ViewportItemState'
import ViewportItemTrajectoryLayers from '../map/ViewportItemTrajectoryLayers'
import ViewportItemTrajectory from '../map/ViewportItemTrajectory'
import {setViewportItemLastStateVisibility, setViewportItemTrajectoryVisibility} from '../state/viewportItemActions';
// import MapFitBoundsRow from '../components/MapFitBoundsRow';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEllipsisH, faToggleOn, faToggleOff,  faEyeSlash, faMapMarkerAlt, faRoute} from '@fortawesome/free-solid-svg-icons'

//import {  useLocation } from "react-router-dom";
//import history from "../util/history";

import { useSelector, useDispatch } from 'react-redux'

export default function ViewportMapContainer(props)  {
  const dispatch = useDispatch(); 
  const [showViewport, setShowViewport] = useState(true); 
  const viewport = useSelector((state) => state.viewport.viewport)
  const map = useSelector((state) => state.ui.map)

  let query = new URLSearchParams(props.location.search)
  let focus = query.getAll('focus') 
    
  if (! viewport.items ) {
    return (<div></div>)  ;
  }

  // click handlers: 
  const setViewportItemLastStateVisibility2 = (viewportItemId, visibility, isDefault) => {
    dispatch (setViewportItemLastStateVisibility(viewportItemId, visibility, isDefault))
  }
  const setViewportItemTrajectoryVisibility2 =  (viewportItemId, visibility, isDefault) => {
    dispatch ( setViewportItemTrajectoryVisibility(viewportItemId, visibility, isDefault) )
  }
  // for all items: 
    
  var ret = []
  // to handle creating / managing layers separately: 
  ret.push(<ViewportItemTrajectoryLayers key='trajectoryLayers'/>)

  ret.push(
    viewport.items.map( (item, index) => {
      const conf = JSON.parse(item.config)
      // exclude hidden items: 
      if ((conf) && (conf.hidden)) return ;
      var id = item.viewport_item_id ;
      var key = 'nokey'
      var layerId = 't-default'
      try {
        key = conf.key 
        layerId = conf.layerId
      }
      catch {
        console.log('WARN: invalid item config (no key or layerId can be deduced)')
      }  //const lastStateVisible = useSelector((state) => state.ui.itemLastStateVisible[props.viewportItemId]) ;
 
      // console.log(key, ': ', item.viewport_item_id)
      // item last state + item trajectory on map: 
      // if (item.viewport_item_id == 1356)  console.log("1356 item: ", item) // DEBUG
      // TODO: move ViewportItemState useSelector queries here? 
      return (
        <Fragment key={'row:' + index}>
          <ViewportItemState
            viewportItemId={item.viewport_item_id}
            shortName={item.short_name}
            displayName={item.display_name}
            setLastStateVisibility = {setViewportItemLastStateVisibility2}
            setTrajectoryVisibility = {setViewportItemTrajectoryVisibility2}
            focused = {focus.includes(key)}
            viewportItemKey = {key}
            // TODO: 
            // browserHistory={history}
            initialSubview={props.initialSubview}
          />
          <ViewportItemTrajectory
            shortName={item.short_name}
            displayName={item.display_name}
            viewportItemId={item.viewport_item_id}
            focused = {focus.includes(key)}
            viewportItemKey = {key}
            browserHistory={history}
            initialSubview={props.initialSubview}
            layerId={layerId}
          />
        </Fragment>
       
      ) 
      
    }
  )) 
  return ret 
}